import React, { useCallback, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import JsxPreview from './JsxPreview'
import JsxCode from './JsxCode'

function JsxAttachment ({ attachment }) {
  const [viewMode, setViewMode] = useState('preview')
  const [overrideJsx, setOverrideJsx] = useState(null)

  const handlePreviewChange = useCallback((e, jsx) => {
    setOverrideJsx(jsx)
    setViewMode('preview')
  }, [setOverrideJsx, setViewMode])

  const jsx = useMemo(() => {
    return overrideJsx || attachment.data
  }, [attachment, overrideJsx])

  return (
    <div>
      {viewMode === 'preview' ? (
        <JsxPreview
          jsx={jsx}
          title={attachment?.title}
          onEdit={() => setViewMode('code')}
        />
      ) : (
        <JsxCode
          defaultValue={jsx}
          title={attachment?.title}
          onPreview={handlePreviewChange}
          onReset={handlePreviewChange}
        />
      )}
    </div>
  )
}

JsxAttachment.propTypes = {
  attachment: PropTypes.shape({
    data: PropTypes.any,
    title: PropTypes.string
  })
}

export default JsxAttachment
